@if (order().storageImagesCleaned) {
  <div class="rounded-2xl bg-rejected/20 px-4 py-2 flex items-center gap-2 w-full text-rejected">
    <app-icon name="delete" class="w-5 h-5 text-rejected" />
    <span class="font-semibold">Photos permanently deleted</span>
    @if (order().storageImagesCleanedAt; as cleanedAt) {
      <span>on {{ cleanedAt.toDate() | date:'medium' }}</span>
    }
  </div>
}
